import { Box, Text, Tip } from 'grommet';
import { TItemDefaultField } from '@shared/types';
import { isItemFieldEdited } from '@shared/utils';
import { TItemDefaults } from '@talon/web/lib/api';
import { USD } from '@talon/web/src/utils/currency';

const fieldNames: Record<TItemDefaultField, string> = {
  rate: 'rate',
  p_and_h_multiplier: 'P&H',
  handling_multiplier: 'handling',
  taxes_multiplier: 'taxes',
};

export interface IEditedMarkerProps {
  item: Partial<Record<TItemDefaultField, number>> & { defaults?: TItemDefaults | null };
  field: TItemDefaultField;
  /** Set the value back to the contract's; without it the marker only explains */
  onReset?: () => void;
}

/**
 * A dot beside an estimate item's value that was edited by hand, naming the contract's value and offering
 * to reset to it
 */
export const EditedMarker = ({ item, field, onReset }: IEditedMarkerProps) => {
  if (!item.defaults || !isItemFieldEdited(item, field)) return null;
  const value = item.defaults[field];
  const shown = field === 'rate' ? USD(value) : `${Math.round(value * 10000) / 100}%`;

  return (
    <Tip
      content={
        <Text size="small">
          Edited by hand. The contract’s {fieldNames[field]} is {shown}.{onReset && ' Click to reset.'}
        </Text>
      }
    >
      <Box
        a11yTitle={`Edited by hand: reset ${fieldNames[field]} to ${shown}`}
        background="status-warning"
        round="full"
        width="10px"
        height="10px"
        flex={false}
        // Into the space before its column (with the column's xsmall gap), so the value beside it doesn't move
        margin={{ left: '-16px' }}
        onClick={onReset}
        focusIndicator={false}
      />
    </Tip>
  );
};
